import { useMemo } from 'react';
import { useNavigate, useMutation, useI18n } from '@ywwwtseng/react-kit';
import { type FormElement, Form, validator, useForm } from '@/lib/react-form';

export default function AddChatScreen() {
  const { mutate, isLoading } = useMutation('chat:add');
  const { t } = useI18n();
  const navigate = useNavigate();
  const form = useForm({
    values: {
      default: {
        chat_id: '',
        allow_guest_gifts: '0',
      },
    },
  });

  const elements = useMemo<{ row: FormElement[] }[]>(() => {
    return [
      {
        row: [
          {
            ui: 'description',
            text: t('add_chat.description'),
          },
        ],
      },
      {
        row: [
          {
            ui: 'custom',
            name: 'demo',
            render: () => {
              return (
                <video
                  className="w-full h-[40vh] object-contain bg-black/30 rounded-lg"
                  src="/videos/add-chat-demo.mp4"
                  playsInline
                  webkit-playsinline=""
                  autoPlay
                  loop
                  muted
                />
              );
            },
          },
        ],
      },
      {
        row: [
          {
            ui: 'text',
            label: t('add_chat.chat_id'),
            name: 'chat_id',
            validate: [
              validator.required({
                message: t('validation.required', {
                  name: t('add_chat.chat_id'),
                }),
              }),
            ],
            props: {
              placeholder: '@moonpacketgroup',
            },
            description: (
              <div className="text-placeholder text-xs">
                <div>{t('add_chat.private_group_hint')}</div>
                <div>• {t('add_chat.private_group_step1')}</div>
                <div>• {t('add_chat.private_group_step2')}</div>
              </div>
            )
          },
        ],
      },
      {
        row: [
          {
            ui: 'select',
            label: t('add_chat.allow_guest_gifts'),
            name: 'allow_guest_gifts',
            description: t('add_chat.allow_guest_gifts_description'),
            props: {
              options: [
                {
                  name: t('common.yes'),
                  key: '1',
                },
                {
                  name: t('common.no'),
                  key: '0',
                },
              ],
            },
          },
        ],
      },
    ];
  }, []);

  return (
    <div className="flex flex-col justify-start w-full h-full gap-2 py-3 px-5">
      <Form
        name="add_chat"
        isLoading={isLoading}
        {...form}
        elements={elements}
        submit={{
          label: t('common.add'),
        }}
        onSubmit={(values) => {
          void mutate({
            chat_id: values.chat_id,
            allow_guest_gifts: values.allow_guest_gifts === '1' ? true : false,
          }).then((result) => {
            if (result.ok) {
              navigate(-1);
            }
          });
        }}
      />
    </div>
  );
}
